<template>
  <div class="service-section">
    <ServiceItem
      img-class="leftimg"
      :img-src="require('@/assets/images/home1.png')"
      text-class="lefttext"
      title="SIサービス"
      subtitle="System Integration Services"
      description="SIサービスでは、設計から運用保守まで、一貫したシステムソリューションを提供し、お客様のビジネスを支援します。"
      link="#/services#siservice"
    />
    <ServiceItem
      img-class="rightimg"
      :img-src="require('@/assets/images/home2.png')"
      text-class="righttext"
      title="ソリューション事業"
      subtitle="Solution Development Services"
      description="お客様の課題に応じた柔軟なITソリューションを提供し、業務効率化と革新を支援します。"
      link="#/solution"
    />
    <ServiceItem
      img-class="leftimg"
      :img-src="require('@/assets/images/home3.png')"
      text-class="lefttext"
      title="オフショア開発"
      subtitle="Offshore Development"
      description="高品質かつコスト効率の高いオフショア開発で、お客様の開発ニーズに応えます。"
      link="#/offshore"
    />
    <ServiceItem
      img-class="rightimg"
      :img-src="require('@/assets/images/home4.png')"
      text-class="righttext"
      title="日中貿易事業"
      subtitle="Japan-China Trade Services"
      description="日中間の貿易を円滑にし、ビジネスの架け橋として価値を提供します。"
      link="#/sino-japan-trade"
    />
  </div>
</template>
  
<script>
import ServiceItem from "./ServiceItem.vue";
  
export default {
    name: "ServicesSection",
    components: {
        ServiceItem,
    },

};
</script>
  
  <style lang="scss" scoped>
  .service-section {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 40px;
    width: 100%;
  }
  @media all and (max-width: 1060px) {
    .service-section{
      margin-top: 0%;
    }
  }
  </style>
  